import {
  Alignment as HygraphAlignment,
  Maybe as HygraphMaybe,
} from '@/lib/types';

import { HorizontalAlignment } from '@/enums/horizontal-alignment';

export default function horizontalAlignmentTransformer(
  props: HygraphMaybe<HygraphAlignment> | undefined
) {
  switch (props) {
    case HygraphAlignment.Left:
      return HorizontalAlignment.LEFT;
    case HygraphAlignment.Center:
      return HorizontalAlignment.CENTER;

    case HygraphAlignment.Right:
      return HorizontalAlignment.RIGHT;
    default:
      return undefined;
  }
}
